export default __webpack_public_path__ + "static/media/reddit.77c863f2.svg";